// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"_ma-z","sponsoredAdsCarouselCard":"ana-z","displaySixCardTiles":"bna-z"};